export default "#version 300 es\r\nprecision highp float;\r\n"